module.exports = __webpack_public_path__ + "img/features_header_pembelian.9902f37b.png";